<template>
  <div class="common-table">
    <a-spin :spinning="loading" style="background: #fff;">
      <a-card v-show="loading" :bordered="false">
        <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
      </a-card>
    </a-spin>
    <div v-show="!loading">
      <a-card :bordered="false" class="cbdt-text">
        <div class="membership-box">
          <span v-if="record.membershipCode"><strong>No. </strong> {{ record.membershipCode }}</span>
          <span v-if="record.customerCode"><strong>CDB No. </strong><router-link target="_blank" :to="{ name: 'EditCdbCustomerPageNew', params: { customerIdOrCode:  record.customerCode }}">{{ record.customerCode }}</router-link></span>
        </div>
        <a-row type="flex" v-show="false">
          <a-col flex="auto" v-if="auditStatus === '0'" class="approve-text">
            <span style="margin:0;" v-if="record.membershipCode">No. </span>{{ record.membershipCode }}
            <span v-if="record.customerCode">CDB No. </span><router-link target="_blank" :to="{ name: 'EditCdbCustomerPageNew', params: { customerIdOrCode:  record.customerCode }}">{{ record.customerCode }}</router-link>
            <!-- <a href="#">{{  record.customerCode }}</a> -->
            <a-popconfirm
                placement="top"
                title="Are you sure approve?"
                @confirm="handleApprove"
                okText="Yes"
                cancelText="No"
              >
              <span style="font-size:1rem;font-weight:600">This Membership Need <a style="font-weight:700"> Approve </a>!</span>
            </a-popconfirm>
          </a-col>
          <a-col flex="auto" v-if="auditStatus === '1'" class="approve-text">
            <div style="font-size: 1rem;">
              <div v-if="approvedBy && approvedTime">
                <span style="margin:0;">No. </span>{{ record.membershipCode }}
                <span>CDB No. </span><router-link :to="{ name: 'EditCdbCustomerPage', params: { customerIdOrCode:  record.customerCode }}">{{ record.customerCode }}</router-link>
                <a-icon type="user-add" style="color: #1890ff;margin-left: 40px"/><span style="margin:0;"> Approved By</span> : {{ approvedBy.userName }}
                <a-icon type="history" style="margin-left: 40px;color: #1890ff;"/><span style="margin:0;"> Audit Time</span> : {{ dateTimeFormatB(approvedTime) }}
              </div>
            </div>
          </a-col>
          <a-divider style="margin: 20px 0 10px 0;"  dashed />
        </a-row>
        <!-- 表单 -->
        <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
          <a-row :gutter="10">
            <!-- Last Name -->
            <a-col :xs="24" :lg="4">
              <a-form-item label="Last">
                <a-input
                  :disabled="true"
                  @change="handleNameChange"
                  v-decorator="[
                    'lastName',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input Last Name.',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
            <!-- First Name -->
            <a-col :xs="24" :lg="4">
              <a-form-item label="First">
                <a-input
                  :disabled="true"
                  @change="handleNameChange"
                  v-decorator="[
                    'firstName',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input First Name.',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
            <!-- Middle Name -->
            <a-col :xs="24" :lg="2">
              <a-form-item label="Middle">
                <a-input
                  :disabled="true"
                  @change="handleNameChange"
                  v-decorator="[
                    'middleName',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Please input Middle Name.',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
            <!-- gender -->
            <a-col :xs="24" :lg="2">
              <a-form-item label="Gender">
                <a-select
                  :disabled="true"
                  v-decorator="[
                    'gender',
                    { rules: [{ required: true, message: 'Please select your Gender!' }] },
                  ]"
                >
                  <a-select-option v-for="g in genderList" :key="'gender-' + g.code" :value="g.code">{{ g.enName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- Birthday -->
            <a-col :xs="24" :lg="4">
              <a-form-item label="DOB">
                <a-input
                  :disabled="true"
                  placeholder="mm/dd/yyyy"
                  :maxLength="10"
                  @keyup.enter.stop="refreshCurrentPage"
                  @keypress="handleDateChange"
                  v-decorator="[
                    'birthday',
                    {rules: [{ required: true, message: 'Please input your birthday!' }]}
                  ]"
                />
              </a-form-item>
            </a-col>
            <!-- E-Mail -->
            <a-col :xs="24" :lg="7">
              <a-form-item label="E-Mail">
                <a-input
                  :disabled="true"
                  v-decorator="[
                    'email',
                    {rules: [{ required: true, type: 'email', message: 'Please enter a email.' }]}
                  ]"
                ></a-input>
              </a-form-item>
            </a-col>          
          </a-row>
          <a-row :gutter="10" style="display:flex;padding-right: 0;">
            <!-- Phone -->
            <a-col :xs="24" :lg="7" style="padding-right: 0;">
              <a-form-item label="Phone">
                <PhonenumberInput v-if="phoneNumberData" :disabled="true" :initData="phoneNumberData" @update="handlePhoneNumberUpdata"/>
            </a-form-item>
            </a-col>
            <a-col :xs="24" :lg="2" class="phone-number-extension">
              <a-form-item label=" ">
                <a-input
                  :disabled="true"
                  class="phone-number-extension-input"
                  placeholder="Ext."
                  v-decorator="[
                  'phoneExt',
                    ]"
                />
              </a-form-item>
            </a-col>
            <!-- Website -->
            <a-col :xs="24" :lg="5">
              <a-form-item label="Website">
                <a-select
                  :disabled="true"
                  v-decorator="[
                    'registerSite',
                    { rules: [{ required: true, message: 'Please select your Website!' }] },
                  ]"
                >
                  <a-select-option value="signettours.com">signettours.com</a-select-option>
                  <a-select-option value="signettours.ca">signettours.ca</a-select-option>
                  <a-select-option value="superatours.com">superatours.com</a-select-option>
                  <a-select-option value="superatours.ca">superatours.ca</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- Customer -->
            <a-col :xs="24" :lg="4">
              <a-form-item label="Customer No.">
                <a-input
                  :disabled="true"
                  v-decorator="[
                    'customerCode',
                    {rules: [{ required: false, message: 'Please enter a Customer No.' }]}
                  ]"
                >
                <!-- <span slot="suffix" @click.prevent="showModal">
                    <a style="color: #666;">
                      <a-icon type="search" />
                    </a>
                  </span> -->
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :lg="3">
              <a-form-item label=" " class="searchBox">
                <a href="javascript:;" @click="showModal" style="font-size: 17px;"><a-icon type="search" /></a>
              <!--  <a-button type="link" @click="handleDelete">Delete</a-button> -->
                <a-divider type="vertical" />
                <a-popconfirm
                  title="Are you sure?"
                  ok-text="Yes"
                  cancel-text="No"
                  @confirm="handleDelete"
                >
                  <a href="javascript:;" style="font-size: 17px;"><a-icon type="delete" style="color:#eb2f96;"/></a>
                </a-popconfirm>
              </a-form-item>
            </a-col>
          </a-row>
          <!-- 匹配cdb资料 -->
          <a-modal :visible="showCustomerCodeModal" :maskClosable="false" @cancel="handleCancel" title="Please Select Customer Code" width="780px">
            <div class="table-page-search-wrapper common-table">
              <a-form layout="inline">
                <a-row :gutter="20" type="flex">
                  <a-col style="width:230px;">
                    <a-form-item label="Name">
                      <a-input v-model="queryParam.name" placeholder="Name" @keyup.enter.stop="refreshCurrentPage"/>
                    </a-form-item>
                  </a-col>
                  <a-col>
                    <a-form-item label="DOB" style="width:155px;">
                      <a-input
                        v-model="queryParam.birthday"
                        placeholder="mm/dd/yyyy"
                        :maxLength="10"
                        @keyup.enter.stop="refreshCurrentPage"
                        @keypress="handleDateChange"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col>
                    <a-form-item label="Gender"  style="width:150px;">
                      <a-select v-model="queryParam.gender" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                        <a-select-option value="">All</a-select-option>
                        <a-select-option value="M">Male</a-select-option>
                        <a-select-option value="F">Female</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col>
                    <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                      <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
                      <a-button style="margin-left: 8px" @click="() => queryParam = { name: '', gender: '', birthday: null }">Clear</a-button>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
              <s-table
                ref="table"
                rowKey="id"
                :rowSelection="{ selectedRowKeys: selectedRowKeysArray, onChange: onSelectChange, type: 'radio', columnWidth: 30 }"
                :columns="columns"
                :data="loadData"
              >
                <div slot="fullName" slot-scope="text" class="overflow-hidden">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>{{ text }}</span>
                    </template>
                    <div>
                      <span>{{ text }}</span>
                    </div>
                  </a-tooltip>
                </div>
                <span slot="serial" slot-scope="text, record, index">
                  {{ index + 1 }}
                </span>
              </s-table>
            </div>
            <template slot="footer">
              <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                Confirm
              </a-button>
            </template>
          </a-modal>
          <!-- 隐藏域 -->
          <a-form-item v-show="false"><a-input
            v-decorator="[
            'id',
            {rules: [{ required: false}]}
            ]"/>
          </a-form-item>
        </a-form>
      </a-card>
      <div class="custom-section-box">
        <!-- Coupons -->
        <a-card :bordered="false" v-if="couponList" class="item" style="padding: 0;">
          <div class="title" style="padding: 0;">Coupons</div>
          <coupon-list :initData="couponList" @couponChange="handleCouponChange"></coupon-list>
        </a-card>
        <!-- Coupons Logs-->
        <a-card :bordered="false" v-if="record && record !== ''">
          <cdb-logs v-if="record.customerId && record.customerId.length > 0" :customerId="record.customerId"></cdb-logs>
        </a-card>
        <!-- Coupons Logs-->
        <a-card :bordered="false" v-if="record && record !== ''" class="item" style="padding: 0;">
          <div class="title">Coupons Logs</div>
          <coupon-logs :membershipId="record.id" ref="couponLogsComponent"></coupon-logs>
        </a-card>
      </div>
    </div>
    <footer-tool-bar class="footerBox">
      <!-- <a-button type="primary" html-type="submit" :loading="saving" @click="handleSubmit">Save</a-button> -->
      <a-button style="margin-left: 8px;" :loading="saving" v-if="!editMode" @click="handleGoBack">Cancel</a-button>
      <a-button :loading="saving" v-else @click="handleClose">Close</a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import '@/assets/css/footer.css'
import '@/assets/css/common-table-list.css'
import pick from 'lodash.pick'
import _ from 'lodash'
import moment from 'moment'
import { Gender } from '@/utils/helper/standard-code-utils'
import MembershipApi from '@/api/api-cdb-membership'
import CDBApi from '@/api/api-cdb-customer'
import FooterToolBar from '@/components/FooterToolbar'
import PhonenumberInput from '@/components/input/phonenumber/PhoneNumberInput'
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import CouponList from './components/MembershipCouponList'
import CdbLogs from '../customer/components/CdbCustomerLogs'
import CouponLogs from './components/MembershipCouponLogs'

export default {
  name: 'MembershipEdit',
  components: {
    FooterToolBar,
    PhonenumberInput,
    STable,
    toSTablePage,
    CouponList,
    CdbLogs,
    CouponLogs
  },
  props: {
    record: {
      type: [String, Object],
      default: null
    },
    // 是否直接链接进入编辑模式
    editMode: {
      type: [Boolean],
      default: false
    }
  },
  data () {
    return {
      // 保存状态
      saving: false,
      confirmLoading: false,
      showCustomerCodeModal: false,
      editForm: this.$form.createForm(this),
      // 加载中
      loading: true,
      genderList: Gender.dict,
      phoneNumberData: null,
      approvedBy: null,
      approvedTime: null,
      selectedRowKeysArray: [],
      selectedRowKeys: [],
      selectedRows: [],
      auditStatus: this.record === '' ? '1' : this.record.auditStatus,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { name: '', gender: '', birthday: null },
      // 优惠券列表
      couponList: null,
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: '35px',
          align:'center'
        },
        {
          title: 'Name',
          dataIndex: 'fullName',
          scopedSlots: { customRender: 'fullName' },
          align:'center'
        },
        {
          title: 'Gender',
          dataIndex: 'gender',
          customRender: (value) => (value === 'M') ? 'Male' : 'Female',
          align:'center',
          width: '80px',
        },
        {
          title: 'DOB',
          dataIndex: 'birthday',
          width: '110px',
          customRender: (value) => this.dateFormatB(value),
          align:'center'
        },
        {
          title: 'CDB No.',
          dataIndex: 'customerCode',
          align:'center',
          width: '110px',
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        let queryParme = this.copyDataByJSON(this.queryParam)
        if (queryParme.birthday === null || queryParme.birthday === '') {
          queryParme = pick(queryParme, ['name', 'gender'])
        } else {
          queryParme.birthday = moment(queryParme.birthday).format('YYYY-MM-DD')
        }
        return CDBApi.query(Object.assign(parameter, queryParme))
          .then(res => {
            return toSTablePage(res.data)
          })
      }
    }
  },
  mounted () {
    this.initData(this.record)
  },
  methods: {
    async initData (data) {
      this.loading = true
      this.couponList = null
      this.phoneNumberData = null
      var formData = null
      if (data === '') {
        this.auditApprove = '1'
        this.approvedBy = null
        this.approvedTime = null
        this.membershipCode = null
        // 新增
        formData = { 'id': null, 'lastName': null, 'firstName': null, 'middleName': null, 'gender': null, 'birthday': null, 'email': null, 'registerSite': 'signettours.com', 'customerCode': null,'phoneExt': null }
      } else {
        const res = await MembershipApi.detail(data.id)
        const dbdata = res.data
        this.couponList = dbdata.couponList
        this.approvedBy = dbdata.approvedBy
        this.approvedTime = dbdata.auditTime
        this.membershipCode = dbdata.membershipCode
        this.auditApprove = dbdata.auditApprove
        // 编辑
        formData = pick(dbdata, ['id', 'lastName', 'firstName', 'middleName', 'gender', 'birthday','email', 'registerSite', 'customerCode','phoneExt'])
        if (formData.birthday && formData.birthday !== '') {
          formData.birthday = moment(formData.birthday).format('MM/DD/YYYY')
        }
      }
      let phoneNumberData = null
      // 处理电话号码
      if (data.phoneNumber && data.phoneNumber !== '') {
        phoneNumberData = {
          countryCode: data.phoneCountryCode ? data.phoneCountryCode : 'US',
          countryCallingCode: data.phoneCountryCallingCode,
          isValid: false,
          phoneNumber: data.phoneNumber
        }
      } else {
          phoneNumberData = {
            countryCode: 'US',
            countryCallingCode: '1',
            isValid: false,
            phoneNumber: ''
          }
      }
      this.$nextTick(() => {
        this.editForm.setFieldsValue(formData)
        this.phoneNumberData = phoneNumberData
      })
      this.loading = false
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleApprove () {
      const that = this
      MembershipApi.auditApprove(this.record.id).then(res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('Approve successfully !')
          that.auditStatus = '1'
          that.approvedBy = res.data.approvedBy
          that.approvedTime = res.data.auditTime
          that.membershipCode = res.data.membershipCode
        }
      })
    },
    // 处理了名字变化
    handleNameChange (e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/[^a-zA-Z ]/g, '')
        if (newValue !== '') {
          let newValueArrey = newValue.split(' ')
          newValueArrey = newValueArrey.map(n => {
            return _.capitalize(n)
          })
          newValue = newValueArrey.join(' ')
        }
        e.target.value = newValue
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeysArray = selectedRowKeys
      this.selectedRows = selectedRows
    },
    showModal() {
      const formData = this.editForm.getFieldsValue()
      const queryParam = pick(formData,  ['lastName', 'firstName', 'middleName', 'gender', 'birthday'])
      queryParam.name = ''
      if (queryParam.lastName && queryParam.lastName !== '') {
        queryParam.name = queryParam.lastName
      }
      if (queryParam.firstName && queryParam.firstName !== '') {
        queryParam.name = queryParam.name + ',' + queryParam.firstName
      }
      if (queryParam.middleName && queryParam.middleName !== '') {
        queryParam.name = queryParam.name + ' ' + queryParam.middleName
      }
      this.queryParam = { name: queryParam.name, gender: queryParam.gender, birthday: queryParam.birthday }
      this.showCustomerCodeModal = true
      this.$nextTick(() => {
        this.$refs.table.refresh(true)
      })
    },
    handleCancel () {
      this.showCustomerCodeModal = false
    },
    handleDelete () {
      this.$nextTick(() => {
        this.editForm.setFieldsValue({ customerCode:null })
      })
    },
    handleOk () {
      if(this.selectedRows.length === 0){
				this.$message.error('Please select a customer')
        this.confirmLoading = false
				return
			}
      this.confirmLoading = true
      this.$nextTick(() => {
        this.editForm.setFieldsValue({ 'customerCode':this.selectedRows[0].customerCode })
      })
      this.confirmLoading = false
      this.showCustomerCodeModal = false
    },
    // 处理国家区号输入变更
    handlePhoneNumberUpdata (newValue) {
      this.phoneNumberData = newValue
    },
    handleSubmit (e) {
      e.preventDefault()
      const that = this
      this.saving = true
      const editForm = this.editForm
      const phoneNumberData = that.phoneNumberData
      return new Promise((resolve, reject) => {
        editForm.validateFields((err) => {
          // 如果校验失败直接返回
          if (err) {
            reject()
            this.saving = false
            return
          }
          // 校验电话号码是否有效
          if (phoneNumberData.phoneNumber && phoneNumberData.phoneNumber !== '' && !phoneNumberData.isValid) {
            reject()
            this.saving = false
            return
          }
          var formData = this.editForm.getFieldsValue()
          formData.phoneCountryCode = phoneNumberData.countryCode
          formData.phoneCountryCallingCode = phoneNumberData.countryCallingCode
          formData.phoneNumber = phoneNumberData.phoneNumber
          /* formData.customerCode = phoneNumberData.customerCode */
          formData.birthday = moment(formData.birthday).format('YYYY-MM-DD')
          
          // 添加
          if (formData.id === null) {
            MembershipApi.add(formData).then(res => {
              if (!this.mixinProcessHasBizErrorNotification(res)) {
                this.mixinProcessSuccessNotification('Save successfully !')
                this.handleGoBack()
              }
            }).finally(() => {
              this.saving = false
            })
          }
          // 修改
          if (formData.id !== null) {
            MembershipApi.update(formData.id, formData).then(res => {
              if (!this.mixinProcessHasBizErrorNotification(res)) {
                this.mixinProcessSuccessNotification('Update successfully !')
                if (!this.editMode) {
                  this.handleGoBack()
                }
              }
            }).finally(() => {
              this.saving = false
            })
          }
        })
      })
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    handleCouponChange () {
      this.$refs.couponLogsComponent.refreshLogs()
    },
    handleDateChange (e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/([^0-9|\\/])/, '')
        if (/^[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        if (/^[0-9]{2}\/[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        e.target.value = newValue
        this.queryParam.birthday = newValue
      }
    },
    handleClose () {
      window.close()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .ant-form-item {
  margin-bottom: 0;
}
::v-deep .ant-calendar-picker {
  width: 100%;
}
::v-deep .ant-col .ant-form-item-label {
  line-height: 30px;
}
.phone-number-extension {
  padding-left: 0 !important;
  margin-left: -3px;
}
.phone-number-extension-input {
  height: 40px;
  border-top-left-radius:0;
  border-bottom-left-radius:0;
}
.phone-number-extension ::v-deep .ant-form-item-label > label::after {
  content: '';
}
::v-deep .ant-col .ant-form-item-label {
   font-weight: 600;
}
::v-deep .btn-delete .anticon-delete {
  height: 20px;
}
.searchBox ::v-deep .ant-form-item-label > label::after {
  content: '';
}
// ::v-deep .coupon-box .ant-card-body{
//   padding-top: 5px;
// }
.cbdt-text a {
  text-decoration:underline;
}
.approve-text span{
  font-weight:700;
  margin-left: 40px;
}
.membership-box {
  font-size: 16px;
}
.membership-box > span {
  padding-right: 20px;
}
.overflow-hidden{
  width: 100%;
  position: relative;
  text-align: left;
}
.overflow-hidden > div{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  left: 0;
}
::v-deep .ant-table-tbody > tr > td {
  vertical-align: top;
}
</style>
